import React from 'react';
import ActionButton from './action-button';

class SaveCancelBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      saveDisabled: !!props.saveDisabled,
      cancelDisabled: !!props.cancelDisabled,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      saveDisabled: !!nextProps.saveDisabled,
      cancelDisabled: !!nextProps.cancelDisabled,
    };
  }

  render() {
    return <div style={{ position: 'sticky', bottom: '20px', zIndex: '900' }}>
      <div className="card bg-dark">
        <div className="card-body">
          <div className="row justify-content-center">
            <div className="col-12 col-md-7 col-lg-4">
              <div className="row">
                <div className="col d-grid">
                  <ActionButton className="btn-sm btn-success"
                                action={() => this.props.saveAction()}
                                errorHandler={this.props.errorHandler}
                                disabled={this.state.saveDisabled}>
                    Save
                  </ActionButton>
                </div>
                <div className="col d-grid">
                  <ActionButton className="btn-sm btn-light"
                                action={() => this.props.cancelAction()}
                                errorHandler={this.props.errorHandler}
                                disabled={this.state.cancelDisabled}>
                    Cancel
                  </ActionButton>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  }

}

export default SaveCancelBar;
